var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require(`@/svg/mic-sprite${_vm.positionX}.png`),"width":"13px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }